// Vypisování odpovědi po slovech (P6, docs/04 „Jak má vypadat odpověď v UI“).
// OpenClaw dnes posílá text najednou, takže tempo dělá frontend: zhruba 50 slov za sekundu,
// celé vypsání nejvýš 1,5 s (delší text se zrychlí). Průběžné delty se jen přidají do stejné fronty.

export const BASE_WPS = 50;
export const MAX_SECONDS = 1.5;

/** Hranice slov: index za každým slovem včetně mezer za ním. */
export function wordEnds(text: string): number[] {
  const ends: number[] = [];
  const re = /\S+\s*/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text))) ends.push(m.index + m[0].length);
  return ends;
}

/**
 * Rychlost pro zbývající slova: aspoň BASE_WPS, a tak rychle, aby zbytek doběhl do MAX_SECONDS
 * od chvíle, kdy přibyl text.
 */
export function wordsPerSecond(remainingWords: number): number {
  return Math.max(BASE_WPS, remainingWords / MAX_SECONDS);
}

export class Typewriter {
  private target = '';
  private ends: number[] = [];
  private shownWords = 0;
  private carry = 0;
  private wps = BASE_WPS;

  constructor(initial = '', revealed = false) {
    this.set(initial);
    if (revealed) this.shownWords = this.ends.length;
  }

  set(text: string) {
    // Nahrazení textu, který nenavazuje: začni od společného začátku.
    if (!text.startsWith(this.target.slice(0, this.visibleLength()))) {
      this.shownWords = 0;
    }
    this.target = text;
    this.ends = wordEnds(text);
    this.shownWords = Math.min(this.shownWords, this.ends.length);
    this.wps = wordsPerSecond(this.ends.length - this.shownWords);
  }

  /** Posune vypisování o dt sekund. Vrací true, když se změnil viditelný text. */
  tick(dt: number): boolean {
    if (this.done()) return false;
    this.carry += dt * this.wps;
    const add = Math.floor(this.carry);
    if (add <= 0) return false;
    this.carry -= add;
    this.shownWords = Math.min(this.ends.length, this.shownWords + add);
    return true;
  }

  visibleLength(): number {
    if (this.shownWords === 0) return 0;
    if (this.shownWords >= this.ends.length) return this.target.length;
    return this.ends[this.shownWords - 1];
  }

  visible(): string {
    return this.target.slice(0, this.visibleLength());
  }

  done(): boolean {
    return this.shownWords >= this.ends.length;
  }
}
